import { useSearchParams } from "react-router"

// Reads `?return=<path>` from the URL so the wizard's leave-confirm
// can send the user to an explicit page when entry points opt in
// (ClickUp 869d7d7xz). Returns `null` when there's no usable value;
// callers fall back to history-back, then /dashboard.
//
// Open-redirect guard: only honor in-app paths (single leading
// slash, not protocol-relative). Skip self-referential paths that
// would loop the user back into the wizard.
export function useReturnUrl(): string | null {
  const [searchParams] = useSearchParams()
  const raw = searchParams.get("return")
  if (
    raw &&
    raw.startsWith("/") &&
    !raw.startsWith("//") &&
    !raw.startsWith("/estimates/quick") &&
    !raw.startsWith("/estimates/full")
  ) {
    return raw
  }
  return null
}
